<section class="outer-container">
    <div class="ques-ans-container" data-crlat="srmQuesAnsContainer">
        @for (market of srmEventEntitymarkets; let i = $index; track market.id + $index) {
            <div class="ques-inner-container" data-crlat="srmQuesInnerContainer">
                <div class="ques-title" data-crlat="srmQuesTitle" [textContent]="market.name"></div>
                <div class="checkboxes-body" data-crlat="checkboxes">
                    @for (outcome of market.outcomes; let j = $index; track outcome.id) {
                        <div
                            class="check-area"
                            [ngClass]="{ selected: outcome.isSelected, eventStartDisable: eventStartDisableFlag }"
                            (click)="!eventStartDisableFlag && outcome.marketId == market.id && selectAnswers(market, j, i)"
                            data-crlat="srmCheckArea">
                            @if (outcome.runnerNumber && (isGenericSilk(eventEntity, outcome) || getDefaultSilk(eventEntity, outcome))) {
                                <div id="srm-silk-img" class="silk-img" data-crlat="imageSilk"></div>
                            }
                            @if (outcome.racingFormOutcome?.silkName) {
                                <div
                                    id="srm-silk-img"
                                    class="silk-img"
                                    [ngClass]="
                                        (eventEntity.isUKorIRE ? 'with-default' : 'inter-silk') +
                                        ' ' +
                                        (!outcome.nonRunner && isSilkLoaded ? 'has-img silk-margin' : '')
                                    "
                                    data-crlat="sectionSilkImg">
                                    @if (!outcome.nonRunner) {
                                        <div [ngStyle]="getSilkStyle(market, outcome)" data-crlat="imageSilk"></div>
                                    }
                                </div>
                            }
                            <span [textContent]="getOutcomeName(outcome.name)"></span>
                        </div>
                    }
                </div>
            </div>
        }

        <div class="action-controls">
            <button
                class="srm-cta-btn"
                [disabled]="selectedQbOutcomes.size < 2 || eventStartDisableFlag"
                (click)="showSRMSelectionsInQuickBet()"
                data-crlat="srmCtaBtn">
                <span [textContent]="srmBtnCTA"></span>
            </button>
        </div>
    </div>
</section>

<div class="heuristic-container top-padding">
    @for (marketEntity of eventEntity.markets; track marketEntity.id; let mIndex = $index) {
        <ng-container>
            @if (marketEntity.templateMarketName === winOrEWTemplateMarketName) {
                <accordion
                    [card]="true"
                    [isExpanded]="!marketEntity.collapseMarket"
                    [isHeaderHidden]="true"
                    [ngClass]="{ 'sort-by-enabled': sortOptionsEnabledFn(selectedMarket === winOrEWLabel) }"
                    data-crlat="marketOutcomes">
                    <accordion-body>
                        @if (isNotAntepostOrSpecials && !isSpOnly) {
                            <race-cards-controls
                                class="sort-by-container race-cards-controls"
                                [sortBy]="sortBy"
                                [market]="marketEntity"
                                [isInfoHidden]="isInfoHidden"
                                [isGreyhoundEdp]="false"
                                [sortOptionsEnabled]="sortOptionsEnabledFn(true)"
                                (toggleShowOptions)="toggleShowOptionsFunc(expandedSummary, mIndex, $event)"
                                (toggleShowOptionsGATracking)="toggleShowOptionsGATrackingFunc($event)">
                            </race-cards-controls>
                        }
                        <div class="inner-container">
                            @for (outcomeEntity of marketEntity.outcomes; track outcomeEntity.id; let oIndex = $index) {
                                <div data-crlat="outcomeEntity">
                                    <racing-outcome-card
                                        [eventEntity]="eventEntity"
                                        [marketEntity]="marketEntity"
                                        [outcomeEntity]="outcomeEntity"
                                        [showSummary]="expandedSummary.length && expandedSummary[mIndex][oIndex]"
                                        (expand)="onExpandSection(expandedSummary, mIndex, oIndex)"
                                        [isGreyhoundEdp]="isGreyhoundEdp"
                                        [isEditStable]="false"
                                        [isLastTwo]="oIndex > marketEntity.outcomes.length - 3"
                                        [isLastThree]="oIndex == marketEntity.outcomes.length - 3"
                                        [preEventMarkets]="preEventMarkets">
                                        <price-odds-button-srm
                                            [event]="eventEntity"
                                            [market]="marketEntity"
                                            [outcome]="outcomeEntity"
                                            [nonRunner]="outcomeEntity.nonRunner"
                                            [gtmModuleTitle]="'racecard'"
                                            [priceOddsBtnDisabled]="true">
                                        </price-odds-button-srm>
                                    </racing-outcome-card>
                                </div>
                            }
                        </div>
                    </accordion-body>
                </accordion>
            }
        </ng-container>
    }
</div>
